import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

import Title from './Title';

const ParkingInfo = (props) => {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const { showTitle, showParkingInfo, titleStyles, parkingInfoStyles, parkingInfo } = props;
  return (
    <Box display="flex" flexDirection="column" className={className} style={style}>
      {showTitle && <Title {...titleStyles} />}
      {showParkingInfo && <Text {...parkingInfoStyles}>{parkingInfo}</Text>}
    </Box>
  );
};

ParkingInfo.propTypes = {
  /**
   * Define if showTitle
   */
  showTitle: PropTypes.bool,
  /**
   * Define if showParkingInfo
   */
  showParkingInfo: PropTypes.bool,
  /**
   * Title Styles
   */
  titleStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Directions Styles
   */
  parkingInfoStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * parkingInfo
   */
  parkingInfo: PropTypes.string,
};

ParkingInfo.defaultProps = {
  showTitle: true,
  showParkingInfo: true,
  titleStyles: {},
  parkingInfoStyles: {},
  parkingInfo: '',
};

export default ParkingInfo;
